import React from "react"
import PropTypes from "prop-types"
import Radium from "higher-order-components/configured-radium/"
import { HAS_TOUCH } from "AtomicUtils/environment"

/**
 * Renders an image disclaimer
 * @param {'left'|'right'|'center'} [textAlign='center'] - Text alignment of disclaimer
 * @param {'small'|'normal'} [size='small'] - Text size of disclaimer
 * @param {String} content - Content of disclaimer
 * @param {Boolean} [gradient=true] - Display gradient behind disclaimer
 * @param {Boolean} [uppercase=false] - Display content in uppercase
 * @returns {ReactElement} React Component
 */
const ImageDisclaimer = ({
  textAlign = "center",
  size = "small",
  uppercase,
  gradient = true,
  content,
  active = false
}) => (
  <div data-test={"image-disclaimer"} style={[styles.base(active), gradient && styles.gradient]}>
    <div
      style={[
        styles.label,
        styles[size],
        { textAlign: textAlign },
        uppercase && { textTransform: "uppercase", letterSpacing: "0.15em" }
      ]}>
      {content}
    </div>
  </div>
)

ImageDisclaimer.propTypes = {
  size: PropTypes.oneOf(["small", "normal"]),
  uppercase: PropTypes.bool,
  textAlign: PropTypes.oneOf(["left", "right", "center"]),
  content: PropTypes.node.isRequired,
  gradient: PropTypes.bool,
  active: PropTypes.bool
}

export default Radium(ImageDisclaimer)

const styles = {
  base: active => ({
    position: "absolute",
    zIndex: "20",
    padding: "2em 1em 1em",
    transition: "padding 0.5s",
    bottom: "0",
    left: "0",
    right: "0",
    fontWeight: 600,
    textAlign: "center",
    "@media (min-width: 768px)": {
      padding: !HAS_TOUCH && active ? "1em 1.8em 2.4em" : "2em 1.8em 1.4em"
    }
  }),
  gradient: {
    background: "linear-gradient(to top, rgba(0, 0, 0, .5), rgba(0, 0, 0, 0))"
  },
  label: {
    zIndex: "3",
    lineHeight: "1.5em",
    pointerEvents: "none"
  },
  small: {
    fontSize: "81%"
  },
  normal: {
    letterSpacing: ".2em",
    fontSize: "90%"
  }
}



// WEBPACK FOOTER //
// ./src/containers/image-disclaimer/index.jsx